import { PAGE_DATA_LAYER } from '@/data/constants/gtm';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { HDMUserActionCompletePayload } from '@/data/types/HDMGTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const sendHDMCreateAccountCompleteEvent = async (payload: HDMUserActionCompletePayload) => {
	const { settings, ...eventData } = payload;
	const { ga4, ua } = getGTMConfig(settings);

	if (!ga4 && !ua) return;

	try {
		const tagManagerArgs = {
			dataLayer: {
				...eventData,
			},
			dataLayerName: PAGE_DATA_LAYER,
		};
		TagManager.dataLayer(tagManagerArgs);
	} catch (error) {
		logError(undefined, 'HDMCreateAccountComplete: error pushing event: %o', error);
	}
};
